import React, {useState, useEffect, useMemo} from 'react';
import {useNavigate} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import {Card} from "primereact/card";
import {InputSwitch} from "primereact/inputswitch";

import HelpComponent from "../HelpComponent";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

const _FM_GroupManualdistributeFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const [group, setGroup] = useState({})
  const [defaultBillingData, setDefaultBillingData] = useState({})
  const [priceCategory, setpriceCategory] = useState(null);
  const [priceCategories, setPriceCategories] = useState([]);
  const [guestInfos, setGuestInfos] = useState([]);
  const [guestInfo, setGuestInfo] = useState(null);
  const [reservationStatus, setReservationStatus] = useState('confirmed');
  const [units, setUnits] = useState([]);
  const [countries, setCountries] = useState([]);
  const [guestAssignments, setGuestAssignments] = useState({});
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showOnlyUnitsWithFreeSpace, setShowOnlyUnitsWithFreeSpace] = useState(true);
  const [guestToAssignListScrollable, setGuestToAssignListScrollable] = useState(false);
  const [unitListScrollable, setUnitListScrollable] = useState(false);
  const [fullUnitFeedback, setFullUnitFeedback] = useState({});

  const reservationStatuses = [
    {label: t('pending'), value: 'pending'},
    {label: t('confirmed'), value: 'confirmed'},
  ];

  const customers = useMemo(() => {
    return Array.isArray(group?.customers) ? group.customers : [];
  }, [group?.customers]);
  const remainingGuests = customers.filter((guest) => {
    const guestId = String(guest?.id);
    return guestAssignments[guestId] === null || guestAssignments[guestId] === undefined;
  }).length;

  const getUnitCapacity = (unit) => {
    return (unit?.number_of_single_beds || 0) + (unit?.number_of_double_beds || 0) * 2 + (unit?.number_of_extra_beds || 0);
  };

  const formatGuestName = (guest) => {
    const fullName = [guest?.lastname, guest?.firstname].filter(Boolean).join(' ').trim();
    return fullName || `${t('guest')} #${guest?.id}`;
  };

  const formatGuestGender = (guest) => {
    if (!guest?.gender) return '-';
    if (guest.gender === 'MALE') return t('male');
    if (guest.gender === 'FEMALE') return t('female');
    if (guest.gender === 'OTHER') return t('other');
    return guest.gender;
  };

  const formatGuestAge = (guest) => {
    if (!guest?.birth_date) return '-';
    const birthDate = moment(guest.birth_date);
    if (!birthDate.isValid()) return '-';
    const years = moment().diff(birthDate, 'years');
    return years >= 0 ? years : '-';
  };

  const getGuestsForUnit = (unitId) => {
    const targetUnitId = String(unitId);
    return customers.filter((guest) => guestAssignments[String(guest?.id)] === targetUnitId);
  };

  const getUnassignedGuests = () => {
    return customers.filter((guest) => {
      const assigned = guestAssignments[String(guest?.id)];
      return assigned === null || assigned === undefined;
    });
  };

  const displayedUnits = useMemo(() => {
    if (!showOnlyUnitsWithFreeSpace) return units;
    return units.filter((unit) => {
      const assignedGuestsCount = getGuestsForUnit(unit?.id).length;
      return assignedGuestsCount < getUnitCapacity(unit) || fullUnitFeedback[String(unit?.id)];
    });
  }, [units, showOnlyUnitsWithFreeSpace, guestAssignments, customers, fullUnitFeedback]);

  const onGuestDragStart = (event, guestId) => {
    event.dataTransfer.setData('text/plain', String(guestId));
    event.dataTransfer.effectAllowed = 'move';
    setIsDragging(true);
  };

  const onGuestDragEnd = () => {
    setIsDragging(false);
  };

  const onGuestDrop = (event, unitId = null) => {
    event.preventDefault();
    const guestId = event.dataTransfer.getData('text/plain');
    if (!guestId) return;
    setGuestAssignments((prev) => {
      const next = {
        ...prev,
        [String(guestId)]: unitId === null ? null : String(unitId)
      };
      if (unitId !== null) {
        const targetUnitId = String(unitId);
        const targetUnit = (units || []).find((unit) => String(unit?.id) === targetUnitId);
        const assignedCount = customers.filter((guest) => next[String(guest?.id)] === targetUnitId).length;
        if (targetUnit && assignedCount >= getUnitCapacity(targetUnit)) {
          setFullUnitFeedback((prevFeedback) => ({...prevFeedback, [targetUnitId]: true}));
          setTimeout(() => {
            setFullUnitFeedback((prevFeedback) => {
              const nextFeedback = {...prevFeedback};
              delete nextFeedback[targetUnitId];
              return nextFeedback;
            });
          }, 3000);
        }
      }
      return next;
    });
    setIsDragging(false);
  };

  const onDragOverTarget = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  useEffect(() => {
    apiCall('get', 'guest-information-request-page')
      .then(response => {
        setGuestInfos(response.data.data.items);
        setGuestInfo(response.data.data.items[0].id);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', "group/" + window.App.urlVars().groupId)
      .then(response => {
        setGroup(response.data.data);
        setDefaultBillingData((prev) => ({
          ...prev,
          name_or_company_name: response.data?.data?.company_name,
          email: response.data?.data?.contact_email,
          country: response.data?.data?.contact_nationality,
        }))
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'accommodation')
      .then(response => {
        localStorage.setItem('selectedAccommodation', window.App.urlVars().accommodationId);
        apiCall('get', 'price-category?search[accommodation][operator]=%3D&search[accommodation][value]='
          + window.App.urlVars().accommodationId)
          .then(response => {
            setPriceCategories(response.data.data.items)
            if (response.data.data.items.length > 0) {
              setpriceCategory(response.data.data.items[0].id)
            }
            const reservedFrom = window.App.urlVars().reservedFrom;
            const reservedTo = window.App.urlVars().reservedTo;
            apiCall('get', "residential-unit/available?from=" + (reservedFrom ?? '')
              + "&to=" + (reservedTo ?? '')
              + "&search[accommodation]=" + (window.App.urlVars().accommodationId ?? ''))
              .then(response => {
                setUnits(response.data.data.items);
              })
              .catch(error => {
                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              })
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', 'dictionary/country')
      .then(response => {
        const allCountries = response.data.data;
        const prioritizedCountries = JSON.parse(process.env.REACT_APP_PRIORITIZEDCOUNTRIES || "[]");
        const sortedCountries = [
          ...allCountries.filter((country) => prioritizedCountries.includes(country.code)),
          ...allCountries.filter((country) => !prioritizedCountries.includes(country.code)),
        ];
        setCountries(sortedCountries);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, []);

  useEffect(() => {
    if (!customers.length) {
      setGuestAssignments({});
      return;
    }

    setGuestAssignments((prev) => {
      const validUnitIds = new Set((units || []).map((unit) => String(unit?.id)));
      const next = {};

      customers.forEach((guest) => {
        const guestId = String(guest?.id);
        const previousUnit = prev[guestId];
        next[guestId] = previousUnit && validUnitIds.has(previousUnit) ? previousUnit : null;
      });

      return next;
    });
  }, [customers, units]);

  return (
    <>
      <Panel className={"p-mt-3"}>
        <style>
          {`
            @keyframes unitFullFadeOut {
              0% { opacity: 0; transform: translateY(4px); }
              10% { opacity: 1; transform: translateY(0); }
              80% { opacity: 1; transform: translateY(0); }
              100% { opacity: 0; transform: translateY(-4px); }
            }
          `}
        </style>
        <h3 className={"p-mt-0"}>
          {t('group_manual_distribute')}
        </h3>
        <HelpComponent type={"section"} tabNumber={3} sectionNumber={1}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <HelpComponent type={"field"} field={"price_category"}/>
              <label htmlFor="price_category">{t('pricecategory')}</label>
              <span className="p-d-block">
                    <Dropdown  options={priceCategories}
                              filter
                              optionLabel="name"
                              optionValue="id"
                              id={"price_category"}
                              emptyMessage={t('empty_message')}
                              onChange={(e) => {
                                setpriceCategory(e.value)
                              }}
                              value={priceCategory}
                    />
                  </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <HelpComponent type={"field"} field={"guest_information_request_page"}/>
              <label htmlFor="guest_information_request_page">{t('guest_information_request_page')}</label>
              <span className="p-d-block">
                    <Dropdown  options={guestInfos}
                              optionLabel="name"
                              optionValue="id"
                              id={"guest_information_request_page"}
                              emptyMessage={t('empty_message')}
                              onChange={(e) => {
                                setGuestInfo(e.value)
                              }}
                              value={guestInfo}
                    />
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <HelpComponent type={"field"} field={"status"}/>
              <label htmlFor="reservation_status">{t('status')}</label>
              <span className="p-d-block">
                <Dropdown
                  options={reservationStatuses}
                  optionLabel="label"
                  optionValue="value"
                  id="reservation_status"
                  emptyMessage={t('empty_message')}
                  onChange={(e) => {
                    setReservationStatus(e.value)
                  }}
                  value={reservationStatus}
                />
              </span>
            </div>
          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col p-col-align-center"}>
            <div className={"p-d-flex p-ai-center"}>
              <span className={"p-mr-2"}>{t('guest_to_assign_scrollable')}</span>
              <InputSwitch
                checked={guestToAssignListScrollable}
                onChange={(e) => {
                  setGuestToAssignListScrollable(e.value);
                }}
              />
            </div>
          </div>
          <div className={"p-col p-col-align-center"}>
            <div className={"p-d-flex p-ai-center"}>
              <span className={"p-mr-2"}>{t('unit_list_scrollable')}</span>
              <InputSwitch
                checked={unitListScrollable}
                onChange={(e) => {
                  setUnitListScrollable(e.value);
                }}
              />
            </div>
          </div>
          <div className={"p-col p-col-align-center"}>
            <div className={"p-d-flex p-ai-center p-jc-end"}>
              <span className={"p-mr-2"}>{t('show_only_units_with_free_space')}</span>
              <InputSwitch
                checked={showOnlyUnitsWithFreeSpace}
                onChange={(e) => {
                  setShowOnlyUnitsWithFreeSpace(e.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div
              className={""}
              onDragOver={onDragOverTarget}
              onDrop={(event) => onGuestDrop(event, null)}
            >
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <h4 className={"p-m-0"}>{t('guest_to_assign')}</h4>
                </div>
              </div>
              <div style={{
                height: '360px',
                overflowY: guestToAssignListScrollable ? "scroll" : "hidden",
              }}
              >
                {getUnassignedGuests().map((guest, index, guests) => (
                  <div className={""} key={guest?.id}>
                    <Card
                      className={`${index !== guests.length - 1 ? 'p-mb-3 ' : ''}p-text-nowrap`}
                      style={{cursor: 'move', position: 'relative'}}
                      draggable
                      onDragStart={(event) => onGuestDragStart(event, guest?.id)}
                      onDragEnd={onGuestDragEnd}
                    >
                  <span style={{
                    position: 'absolute',
                    right: '0',
                    bottom: '0',
                    backgroundColor: '#ebedf2',
                    borderBottomRightRadius: '3px',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    lineHeight: 1
                  }}>
                    <i className={"pi pi-th-large"} style={{color: '#495057'}}></i>
                  </span>
                      <span className={"p-text-bold"}>{formatGuestName(guest)}</span>
                      <small className={"p-text-secondary p-pl-2"}>
                        {t('gender')}: {formatGuestGender(guest)} | {t('age')}: {formatGuestAge(guest)}
                      </small>
                    </Card>
                  </div>
                ))}
              </div>

            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div style={{
              height: '360px',
              overflowY: unitListScrollable ? "scroll" : "hidden",
              overflowX: "hidden",
            }}
            >
              {displayedUnits.map((unit) => {
                const unitGuests = getGuestsForUnit(unit?.id);
                const isUnitFull = unitGuests.length >= getUnitCapacity(unit);
                return (
                  <div className={""} key={unit?.id}>
                    <div className={"p-grid"}>
                      <div className={"p-col-12 p-lg-6"}>
                        <h4 className={"p-m-0"}>{unit?.name}</h4>
                      </div>
                      <div className={"p-col-12 p-lg-6 p-text-right"}>
                        <small className={"p-text-secondary"}>
                          {t('capacity_places')}: {getUnitCapacity(unit)}
                        </small>
                      </div>
                    </div>
                    {unitGuests.map((guest, index, guests) => {
                      return (
                        <Card
                          key={guest?.id}
                          className={'p-mb-3 p-text-nowrap'}
                          style={{cursor: 'move', position: 'relative'}}
                          draggable
                          onDragStart={(event) => onGuestDragStart(event, guest?.id)}
                          onDragEnd={onGuestDragEnd}
                        >
                          <span style={{
                            position: 'absolute',
                            right: '0',
                            bottom: '0',
                            backgroundColor: '#ebedf2',
                            borderBottomRightRadius: '3px',
                            width: '24px',
                            height: '24px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            lineHeight: 1
                          }}>
                            <i className={"pi pi-th-large"} style={{color: '#495057'}}></i>
                          </span>
                          <span className={"p-text-bold"}>{formatGuestName(guest)}</span>
                          <small className={"p-pl-2 p-text-secondary"}>
                            {t('gender')}: {formatGuestGender(guest)} | {t('age')}: {formatGuestAge(guest)}
                          </small>
                        </Card>
                      )
                    })}
                    {!isUnitFull &&
                      <div
                        className={`dropzone p-mb-3 ${isDragging ? 'active' : ''}`}
                        style={{
                          minHeight: '50px',
                          borderColor: '#ced4da',
                          background: '#fff',
                          border: '2px dashed #e6e9ec',
                          borderRadius: '4px',
                        }}
                        onDragOver={onDragOverTarget}
                        onDrop={(event) => onGuestDrop(event, unit?.id)}
                      >
                      </div>
                    }
                    {isUnitFull && fullUnitFeedback[String(unit?.id)] &&
                      <div
                        className={"p-mb-3"}
                        style={{
                          minHeight: '50px',
                          border: '1px solid #34a853',
                          background: '#e8f7ed',
                          color: '#1f7a37',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 600,
                          animation: 'unitFullFadeOut 3s ease forwards'
                        }}
                      >
                        {t('unit_filled')}
                      </div>
                    }
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className={"p-grid p-mb-4"}>
          <div className={"p-col-12"}>
            <h3 className={"p-mt-0 p-mb-3"}>{t('summary')}</h3>
            <HelpComponent type={"section"} tabNumber={3} sectionNumber={2}/>
            {units && units[0] &&
              <DataTable
                size={"small"}
                emptyMessage={t('empty_message')}
                value={units}
                loading={loading}
                autoLayout={true}
                responsiveLayout={window.App.state.responsiveLayout}
                breakpoint="1365px"
                stripedRows
                dataKey="id"
              >
                <Column field="id" header={'#'}/>
                <Column field="name" header={t('name')}/>
                <Column field="number_of_single_beds" header={t('number_of_single_beds')}></Column>
                <Column field="number_of_double_beds" header={t('number_of_double_beds')}></Column>
                <Column field="number_of_extra_beds" header={t('number_of_extra_beds')}></Column>
                <Column header={t('guests')} body={(rowData) => {
                  return getGuestsForUnit(rowData?.id).length;
                }}/>
              </DataTable>
            }
          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col p-col-align-center"}>
            <h3 className={"p-m-0"}>{t('billing')}</h3>
          </div>
        </div>
        <div className={"billing"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <div className="p-field p-fluid">
                <label htmlFor="name_or_company_name">{t('name_or_company_name')}</label>
                <span className="p-d-block">
                          <InputText id="name_or_company_name"
                                     onChange={(e) => {
                                       setDefaultBillingData((prev) => ({
                                         ...prev,
                                         name_or_company_name: e.target.value
                                       }))
                                     }}
                                     value={defaultBillingData?.name_or_company_name}
                          />
                        </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label htmlFor="vat_number">{t('vat_number')}</label>
                <span className="p-d-block">
                          <InputText id="vat_number"
                                     onChange={(e) => {
                                       setDefaultBillingData((prev) => ({
                                         ...prev,
                                         vat_number: e.target.value
                                       }))
                                     }}
                                     value={defaultBillingData?.vat_number}
                          />
                        </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <div className="p-field p-fluid">
                <label htmlFor="email">{t('email')}</label>
                <span className="p-d-block">
                          <InputText id="email"
                                     onChange={(e) => {
                                       setDefaultBillingData((prev) => ({
                                         ...prev,
                                         email: e.target.value
                                       }))
                                     }}
                                     value={defaultBillingData?.email}
                          />
                        </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label htmlFor="country">{t('country')}</label>
                <span className="p-d-block">
                          <Dropdown  options={countries}
                                    filter
                                    optionLabel="name"
                                    optionValue="code"
                                    id={"country"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setDefaultBillingData((prev) => ({
                                        ...prev,
                                        country: e.value
                                      }))
                                    }}
                                    value={defaultBillingData?.country}
                          />
                        </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label htmlFor="zip_code">{t('zip_code')}</label>
                <span className="p-d-block">
                          <InputText id="zip_code"
                                     onChange={(e) => {
                                       setDefaultBillingData((prev) => ({
                                         ...prev,
                                         zip_code: e.target.value
                                       }))
                                       if (e.target.value.length >= 4) {
                                         window.App.zipCode(e.target.value, (city) => {
                                           setDefaultBillingData(prev => ({
                                             ...prev,
                                             city: city
                                           }));
                                         });
                                       }
                                     }}
                                     value={defaultBillingData?.zip_code}
                          />
                        </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label htmlFor="city">{t('city')}</label>
                <span className="p-d-block">
                          <InputText id="city"
                                     onChange={(e) => {
                                       setDefaultBillingData((prev) => ({
                                         ...prev,
                                         city: e.target.value
                                       }))
                                     }}
                                     value={defaultBillingData?.city}
                          />
                        </span>
              </div>
            </div>
            <div className={"p-col-12 p-lg-5"}>
              <div className="p-field p-fluid">
                <label htmlFor="street_and_number">{t('street_and_number')}</label>
                <span className="p-d-block">
                          <InputText id="street_and_number"
                                     onChange={(e) => {
                                       setDefaultBillingData((prev) => ({
                                         ...prev,
                                         street_and_number: e.target.value
                                       }))
                                     }}
                                     value={defaultBillingData?.street_and_number}
                          />
                        </span>
              </div>
            </div>
          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col"}>
          </div>
          <div className={"p-col p-text-right p-col-align-center"}>
            <Button type="button" aria-label={t('save')} icon={"pi pi-save"}
                    label={t('save')}
                    loading={loading}
                    onClick={() => {
                      if (remainingGuests === 0) {
                        setLoading(true)
                        let _reservations = []
                        units.forEach((unit) => {
                          const guestsInUnit = getGuestsForUnit(unit?.id);
                          if (!guestsInUnit.length) return;
                          _reservations.push({
                            reserved_from: group.from,
                            reserved_to: group.to,
                            residential_unit: unit?.id,
                            priceCategory: priceCategory,
                            channel: 1,
                            contactName: group.contact_name,
                            contactEmail: group.contact_email,
                            numberOfGuests: guestsInUnit.length,
                            customers: guestsInUnit.map((guest) => guest?.id),
                            guest_information_request_page: guestInfo,
                          })
                        })
                        apiCall('post', 'reservation-group/bulk', {
                          status: reservationStatus,
                          reservationGroup: {
                            defaultBillingData: defaultBillingData,
                          },
                          reservations: _reservations
                        })
                          .then(response => {
                            window.App.toastShow('success', t('success'), response.data.message)
                            navigate(-1)
                            setLoading(false)
                          })
                          .catch(error => {
                            setLoading(false)
                            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                          })
                      } else {
                        window.App.customToastShow('warn', t('warning'), t('not_all_guests_set'))
                      }
                    }}
                    className="p-button-success p-ml-2"/>
          </div>
        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(_FM_GroupManualdistributeFormComponent);
